/**
 * AuditIQ Icon System
 * Gold, flat, consistent-thickness wrappers around lucide-react icons.
 * Use these wrappers (not raw lucide icons) to enforce brand standard.
 */
import React from "react";
import {
  ShieldCheck, Wrench, Landmark, DollarSign, Droplets,
  AlertTriangle, Radio, Sparkles, Activity, CheckCircle2,
} from "lucide-react";
import { ICON_RULES } from "./tokens";

const Wrap = ({ Icon, size = 24, className = "", testid, ...rest }) => (
  <Icon
    size={size}
    strokeWidth={ICON_RULES.strokeWidth}
    className={`text-gold ${className}`}
    data-testid={testid}
    {...rest}
  />
);

export const IconCyber         = (p) => <Wrap Icon={ShieldCheck}     testid="icon-cyber" {...p} />;
export const IconInfrastructure= (p) => <Wrap Icon={Wrench}          testid="icon-infra" {...p} />;
export const IconGovernment    = (p) => <Wrap Icon={Landmark}        testid="icon-gov"   {...p} />;
export const IconBudget        = (p) => <Wrap Icon={DollarSign}      testid="icon-budget" {...p} />;
export const IconWater         = (p) => <Wrap Icon={Droplets}        testid="icon-water" {...p} />;
export const IconRiskAlert     = (p) => <Wrap Icon={AlertTriangle}   testid="icon-risk"  {...p} />;
export const IconSensors       = (p) => <Wrap Icon={Radio}           testid="icon-sensor" {...p} />;
export const IconAI            = (p) => <Wrap Icon={Sparkles}        testid="icon-ai"    {...p} />;
export const IconDataMonitor   = (p) => <Wrap Icon={Activity}        testid="icon-data"  {...p} />;
export const IconCompliance    = (p) => <Wrap Icon={CheckCircle2}    testid="icon-compliance" {...p} />;

export const ICON_REGISTRY = [
  { key: "cybersecurity",  Component: IconCyber,          label: "Cybersecurity" },
  { key: "infrastructure", Component: IconInfrastructure, label: "Infrastructure" },
  { key: "government",     Component: IconGovernment,     label: "Government" },
  { key: "budget",         Component: IconBudget,         label: "Budget" },
  { key: "water",          Component: IconWater,          label: "Water Systems" },
  { key: "risk-alert",     Component: IconRiskAlert,      label: "Risk Alerts" },
  { key: "sensors",        Component: IconSensors,        label: "Sensors" },
  { key: "ai",             Component: IconAI,             label: "AI Systems" },
  { key: "data-monitoring",Component: IconDataMonitor,    label: "Data Monitoring" },
  { key: "compliance",     Component: IconCompliance,     label: "Compliance" },
];
